module.exports = __webpack_public_path__ + "media/images/new-ui-images/overdue-time-7db060b92f7af7345a8ebc88e07018b5.png";